import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import _ from 'lodash';
import {confirmAlert} from "react-confirm-alert";
import {formatMoney} from "accounting-js";
import ActivityAdd from './../../elements/activities/widget/activity_add';
import ActivitiesSearch from './../../elements/activities/widget/activities_search';

class Activities extends Component {
	render(){
		return(
			<ActivitiesList {...this.props}/>
		);
	}

	componentWillMount(){
		this.props.activitiesShow();
	}
}

export class ActivitiesList extends Component{
	render() {
		const { activities } = this.props;

		let au = _.find(activities.permissions, (o) => {return o==='Update'});
		let ad = _.find(activities.permissions, (o) => {return o==='Delete'});
		return (
			<div>
				{activities.isFetching ? <Loading /> :
					<table className={`inm-table`}>
						<thead>
						<tr>
							<th>ID</th>
							<th>Actividad</th>
							<th>Monto</th>
						</tr>
						</thead>
						<tbody>
						{!_.isEmpty(activities.list) ? _.map(activities.list, (row, k) => {
							return (
								<tr key={k}>
									<td style={{width:10+'%'}}>
										<div className="actions">
											{au ? <NavLink to={`/proigualdad/actividades/editar/${row.id}`}><i className="fa fa-edit"></i></NavLink>:''}
											{ad ? <button onClick={() => this._getConfirm(row.id, row.name)}><i className="fa fa-trash-o"></i></button>:''}
										</div>
										{row.id}
									</td>
									<td><strong>{row.name}</strong></td>
									<td>{formatMoney(row.amount)}</td>
								</tr>
							)
						}) :
							<tr>
								<td colSpan={3}>No hay actividades</td>
							</tr>}
						</tbody>
					</table>}
				{activities.pages.total>20 &&
				<InmPagination
					key="concepts-pages"
					current={activities.pages.current}
					total={activities.pages.total}
					nextPage={this._handlePageChange}
				/>}
			</div>
		)
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar la actividad "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.deleteActivity(id)
		})
	}

	_handlePageChange(value) {
		const { activities } = this.props;
		this.props.activitiesShow(value, activities.filters);
	}
}

export default BaseLayout(Activities, {
	title: `Administrar Actividades`,
	subnav: {
		icon: 'fa-calendar-check-o',
		name: 'Proigualdad',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Buscar',
				element: <ActivitiesSearch />
			},
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <ActivityAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/activities/index.jsx